import { getShareLinkRecipientUnread } from "routes/schedule/plugins/share-link-comments/share-link-comments.controller"
import { CommentsTabUnreadLabel } from "./comments-tab-unread-label"

// Recipient (sharee) Comments tab label: shows the count of their own threads with replies /
// resolutions they have not yet viewed. Reads its own count so the label updates (via the
// ShareLinkComment + read-state invalidation groups) without re-running the tab registrar.
export function ShareCommentsTabLabel({ shareLinkId, regimeId }) {
    const unread = getShareLinkRecipientUnread.useResults({ shareLinkId, regimeId })
    return <CommentsTabUnreadLabel total={unread?.total ?? 0} />
}
